/**
 * @module app.shared
 */

export class IfValueConverter<T> {

    public toView(value: T, condition: boolean): T | null {
        return condition ? value : null;
    }

}

/**
 *
 * Example Usage:
 *
 *      ${booleanProperty | toggle:'enabled'}
 *          equivalent to: ${booleanProperty ? 'enabled' : ''}
 *
 *      ${booleanProperty | toggle:'enabled':'disabled'}
 *          equivalent to: ${booleanProperty ? 'enabled' : 'disabled'}
 *
 * */
export class ToggleValueConverter {

    public toView(condition : boolean, trueResult? : any, falseResult? : any) : any {
        if(trueResult === undefined) { trueResult = ""; }
        if(falseResult === undefined) { falseResult = ""; }
        return condition ? trueResult : falseResult;
    }

}

export class OverrideValueConverter {

    public toView(value: unknown, override: unknown): any {
        if(override) {
            return override;
        }
        return value;
    }

}
